import React, { FC } from 'react';
import StarIcon from 'src/shared/material_icons/toggle/star.svg';
import StarBorderIcon from 'src/shared/material_icons/toggle/star_border.svg';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { Icon } from '../icon';
import { isPageHeaderStarrableKey, isStarExcludedKey, useStarredMenu } from '../leftAppSidebar/StarredMenu';
import { ZTooltip } from '../ztooltip';

const StarButton = styled.button<{ $active?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    margin-left: 8px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    color: ${(props) => (props.$active ? '#f5a623' : '#bdbdbd')};
    transition: color 0.15s ease;

    &:disabled {
        cursor: default;
    }

    &:hover {
        color: ${(props) => (props.$active ? '#e0951c' : '#f5a623')};
    }

    ${Icon} {
        width: 20px;
        height: 20px;
        min-width: 20px;
    }

    svg {
        width: 20px;
        height: 20px;
        fill: currentColor;
    }
`;

// Clickable star shown next to a page title. Toggles the page (identified by its
// menu `pageKey`) in/out of the user's starred pages, shared with the sidebar.
export const PageHeaderStar: FC<{ pageKey?: string }> = ({ pageKey }) => {
    const { isWithinProvider, isStarredKey, toggleStarKey, isSaving } = useStarredMenu();

    if (!pageKey || !isWithinProvider || isStarExcludedKey(pageKey) || !isPageHeaderStarrableKey(pageKey)) return null;

    const active = isStarredKey(pageKey);
    const label = active ? T._('Remove from starred', 'Admin') : T._('Add to starred', 'Admin');

    return (
        <ZTooltip position='top' title={label}>
            <StarButton
                type='button'
                $active={active}
                disabled={isSaving}
                aria-label={label}
                aria-pressed={active}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleStarKey(pageKey);
                }}
            >
                <Icon>{active ? <StarIcon /> : <StarBorderIcon />}</Icon>
            </StarButton>
        </ZTooltip>
    );
};
